export * from './delete-objekt-art-request.interface';
export * from './delete-objekt-art-response.interface';
export * from './delete-objekt-art.shapes';
